import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import AdvanceSelect from '../../../common/AdvanceSelect';
import {getIncomeCards, getIncomeCardsCacheKey} from '../../../../redux/boxSlice';
import FormInput from '../../../common/FormInput';

const IncomeCardSelect = ({locationId, value, onChange, label, isClearable = false}) => {
    const dispatch = useDispatch();
    const cacheKey = getIncomeCardsCacheKey(locationId);
    const hasCachedOptions = useSelector((state) => !!state.box.box.incomeCardsByLocationId?.[cacheKey]);
    const options = useSelector((state) => state.box.box.incomeCardsByLocationId?.[cacheKey] ?? []);

    useEffect(() => {
        if (!hasCachedOptions) {
            dispatch(getIncomeCards(locationId));
        }
    }, [dispatch, locationId, hasCachedOptions]);

    const initValue = useMemo(() => value ?? null, [value]);

    return (
        <FormInput label={label} width={'100%'} containerProps={{mb: 0}}>
            <AdvanceSelect
                dontSort
                options={options}
                initValue={initValue}
                onChange={(option) => onChange(option?.value ?? null)}
                isClearable={isClearable}
            />
        </FormInput>
    );
};

export default IncomeCardSelect;
